import React from 'react';
import styled from 'styled-components';
import { adminTheme } from '../../theme-admin';

const StyledCard = styled.div`
  background: ${adminTheme.colors.background.primary};
  border-radius: ${adminTheme.borderRadius.xl};
  box-shadow: ${adminTheme.shadows.md};
  overflow: hidden;
  transition: ${adminTheme.transitions.normal};
  border: 1px solid ${adminTheme.colors.gray[200]};

  ${props => props.$hoverable && `
    cursor: pointer;
    &:hover {
      transform: translateY(-2px);
      box-shadow: ${adminTheme.shadows.lg};
    }
  `}

  ${props => props.$glass && `
    background: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.3);
  `}
`;

const CardHeader = styled.div`
  padding: ${adminTheme.spacing.lg} ${adminTheme.spacing.xl};
  border-bottom: 1px solid ${adminTheme.colors.gray[200]};
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${props => props.$gradient && `
    background: ${props.$gradient};
    color: white;
    border-bottom: none;
  `}
`;

const CardTitle = styled.h3`
  font-family: ${adminTheme.fonts.heading};
  font-size: ${adminTheme.fontSizes.lg};
  font-weight: ${adminTheme.fontWeights.semibold};
  margin: 0;
  color: ${props => props.$gradient ? 'white' : adminTheme.colors.gray[900]};
`;

const CardBody = styled.div`
  padding: ${adminTheme.spacing.xl};
`;

const CardFooter = styled.div`
  padding: ${adminTheme.spacing.lg} ${adminTheme.spacing.xl};
  border-top: 1px solid ${adminTheme.colors.gray[200]};
  background: ${adminTheme.colors.gray[50]};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export default function Card({ 
  title, 
  children, 
  footer, 
  actions,
  hoverable,
  glass,
  gradient,
  headerGradient,
  ...props 
}) {
  return (
    <StyledCard $hoverable={hoverable} $glass={glass} {...props}>
      {title && (
        <CardHeader $gradient={headerGradient}>
          <CardTitle $gradient={headerGradient}>{title}</CardTitle>
          {actions && <div>{actions}</div>}
        </CardHeader>
      )}
      <CardBody>{children}</CardBody>
      {footer && <CardFooter>{footer}</CardFooter>}
    </StyledCard>
  );
}
